// src/version.js
//
// Single source of truth for the *frontend* product version.
// Praxxis is versioned with SemVer (MAJOR.MINOR.PATCH). Bump APP_VERSION here
// AND in package.json ("version") on every release, and keep it in lock-step
// with the backend (Module1/config/version.py). See VERSIONING.md.
//
// The git SHA + build date are stamped in at build time by CI via the
// REACT_APP_GIT_SHA / REACT_APP_BUILD_DATE environment variables (CRA inlines
// any REACT_APP_* var at build). Locally they fall back to 'dev' / ''.

export const APP_NAME = 'Praxxis';

// Keep in sync with package.json "version".
export const APP_VERSION = '1.0.0';

export const BUILD_SHA = (process.env.REACT_APP_GIT_SHA || 'dev').slice(0, 12);
export const BUILD_DATE = process.env.REACT_APP_BUILD_DATE || '';

// SemVer + build metadata, e.g. "1.0.0+a1b2c3d4e5f6".
export const FULL_VERSION =
  BUILD_SHA && BUILD_SHA !== 'dev' ? `${APP_VERSION}+${BUILD_SHA}` : APP_VERSION;
